import LocalAdmin from './LocalAdmin';

export default LocalAdmin;
